import { render, staticRenderFns } from "./A05.vue?vue&type=template&id=57d5e96c&"
import script from "./A05.vue?vue&type=script&lang=js&"
export * from "./A05.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "A05.vue"
export default component.exports